import graphql__851cb6ff9f61848a2be3 from "./__generated__/TransferAppConfirmationModalQuery.graphql.ts";import { MessagePanel } from '@portal/components'
import graphql from 'babel-plugin-relay/macro'
import ConfirmationModal from 'components/confirmation/ConfirmationModal'
import TextBoxConfirmation from 'components/confirmation/TextBoxConfirmation'
import React, { useState } from 'react'
import { useLazyLoadQuery } from 'react-relay/hooks'

import { TransferAppConfirmationModalQuery } from './__generated__/TransferAppConfirmationModalQuery.graphql'

const query = graphql__851cb6ff9f61848a2be3

type Props = {
  /** True if the modal is open. */
  isOpen: boolean
  /** Callback for closing the modal */
  onClose: (transfer: boolean) => void
  /** ID of the app being transferred. */
  appId: string
  /** Destination tenant. */
  destination: string
  /** True if a transfer request id being processed. */
  isProcessing: boolean
}

/** Modal used to confirm that a request should be made to transfer an app to a different tenant. */
const TransferAppConfirmationModal: React.FC<Props> = ({
  isOpen,
  onClose,
  appId,
  destination,
  isProcessing,
}) => {
  const { viewer } = useLazyLoadQuery<TransferAppConfirmationModalQuery>(
    query,
    { id: appId },
  )

  const [isMatch, setIsMatch] = useState(false)
  const appSlug = viewer.appById?.slug

  return (
    <ConfirmationModal
      open={isOpen}
      onCancel={() => onClose(false)}
      onConfirm={() => onClose(true)}
      title="Transfer app"
      confirmButtonText="Confirm"
      cancelButtonDisabled={isProcessing}
      confirmButtonDisabled={!isMatch || isProcessing}
      variant="warning"
      description="Are you sure you want to transfer your app?"
    >
      <MessagePanel
        variant="danger"
        message={() => (
          <>
            Once the transfer of app{' '}
            <span className="font-medium">{`"${appSlug}"`}</span> has been
            accepted by{' '}
            <span className="font-medium">{`"${destination}"`}</span> this
            action cannot be undone.
          </>
        )}
        className="mb-8"
      />
      <TextBoxConfirmation onMatch={setIsMatch} value={appSlug || ''} />
    </ConfirmationModal>
  )
}

export default TransferAppConfirmationModal
